export const intentionalyFloatingPromiseReturn = <ARGS extends unknown[]>(
    fn: (...args: ARGS) => Promise<unknown>,
): ((...args: ARGS) => void) => {
    return (...args) => {
        fn(...args).catch(() => {
            throw new Error('something went wrong');
        });
    };
};

// -? remove optionality
type Entries<T> = {
    [K in keyof T]-?: [K, NonNullable<T[K]>];
}[keyof T][];

export function entries<T extends object>(obj: T): Entries<T> {
    if (!obj) {
        return [] as Entries<T>;
    }
    return Object.entries(obj) as Entries<T>;
}

export function debounce<A = unknown, R = void>(fn: (args: A) => R, ms: number): [(args: A) => Promise<R>, () => void] {
    let timer: NodeJS.Timeout;

    const debouncedFunc = (args: A): Promise<R> =>
        new Promise((resolve) => {
            if (timer) {
                clearTimeout(timer);
            }

            timer = setTimeout(() => {
                resolve(fn(args));
            }, ms);
        });

    const teardown = () => clearTimeout(timer);

    return [debouncedFunc, teardown];
}
